import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import {Md5} from 'ts-md5/dist/md5';
import { SessionService } from '../../session.service'
import { environment } from 'environments/environment.prod';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
@Component({
  selector: 'page-sign-in',
  templateUrl: './sign-in.html',
  styleUrls: ['./sign-in.scss']
})
export class PageSignIn1Component implements OnInit {
  password:string;
  username:string;hashPassword:string;
  permission:string;
  name:string;
  userid:string;
  loginFail:boolean;
  deny:boolean;
  sysName:string = environment.sysName;
  sysVersion:string = environment.sysVersion;
  constructor(public dialog: MdDialog,private _sessionService:SessionService, private _md5:Md5,private router: Router) {
    this.loginFail=false;
    this.deny=false;
   // _md5.appendStr();

  }

  ngOnInit() { 
    
  }

  onSubmit() {
    ////console.log('username : ',this.username);
    if(this.username!=undefined && this.password!=undefined){


      this.fetchData((data)=>{
        this.hashPassword = Md5.hashStr(this.password).toString();
        if(this.hashPassword==data[3]){
         this.permission=data[5];
         this.userid=data[0];
         this.name=data[1];
      //let hashPassword = Md5.hashStr('1234567');
      this._sessionService.setSessionLogin();
      this._sessionService.setSessionPermission(this.permission);
      this._sessionService.setSessionUserId(this.userid);
      this._sessionService.setSessionName(this.name);
      //console.log('session : ',this._sessionService.getSessionLogin(),this.permission,this._sessionService.getSessionPermission());
          //console.log('-------login success-----');
          let dialogRef = this.dialog.open(signInDialog, { disableClose: true });
          let instance = dialogRef.componentInstance;
          instance.Message = "wait.....";
          //1=admin,2=ceo,3=pc1,4=pc2,5=pu,6=qc
          
          if(data[5]=="1"){
            //this.router.navigate(['/default-layout/dashboard']);
            this.router.navigate(['/default-layout/home']);
            
          }else if(data[5]=="2"){
            this.router.navigate(['/default-layout/home']);
            //this.router.navigate(['/default-layout/dashboard']);
          }else if(data[5]=="3"){
            this.router.navigate(['/default-layout/home']);
          }else if(data[5]=="4"){
            this.router.navigate(['/default-layout/home']);
          }else if(data[5]=="5"){
            this.router.navigate(['/default-layout/home']);
          }else if(data[5]=="6"){
            this.router.navigate(['/default-layout/home']);
          }else if(data[5]=="7"){
            this.router.navigate(['/default-layout/home']);
          }
          else if(data[5]=="13"){
            this.router.navigate(['/extra-layout/pd-monitor-1']);
          }else if(data[5]=="14"){
            this.router.navigate(['/extra-layout/control-chart']);
          }
          else if(data[5]=="15"){
            this.router.navigate(['/extra-layout/mobile-prod-check-sheet']);
          }
          else if(data[5]=="16"){
            this.router.navigate(['/extra-layout/moble-prod-check-result']);
          }
          else if(data[5]=="17"){
            this.router.navigate(['/extra-layout/pd-monitor-2']);
            
          }
          else if(data[5]=="22"){
            this.router.navigate(['/extra-layout/pd-monitor-8']);
            
          }
          else if(data[5]=="23"){
            this.router.navigate(['/extra-layout/pd-monitor-9']);
            
          }
          else if(data[5]=="18"){
            this.router.navigate(['/extra-layout/production-control']);
          }
          else if(data[5]=="19"){
            this.router.navigate(['/extra-layout/fg-monitor-1']);
          }
          else if(data[5]=="24"){
            this.router.navigate(['/extra-layout/fg-monitor-2']);
          }
          else if(data[5]=="25"){
            this.router.navigate(['/extra-layout/fg-monitor-3']);
          }
          else if(data[5]=="20"){
            this.router.navigate(['/extra-layout/rm-monitor-1']);
          }
          else if(data[5]=="21"){
            this.router.navigate(['/extra-layout/rm-monitor-2']);
          }
          else if(data[5]=="26"){
            this.router.navigate(['/extra-layout/rm-monitor-3']);
          }
          else if(data[5]=="27"){
            this.router.navigate(['/extra-layout/rm-monitor-4']);
          }
          else if(data[5]=="28"){
            this.router.navigate(['/extra-layout/rm-monitor-5']);
          }
          else if(data[5]=="29"){
            this.router.navigate(['/extra-layout/rm-monitor-6']);
          }
          else if(data[5]=="30"){
            this.router.navigate(['/extra-layout/rm-monitor-7']);
          }
          else{
            this.router.navigate(['/extra-layout/sign-in']);
            this.deny=true;
            this.loginFail=false;
          }
          

        }else{
          //console.log('-------login failed-----');
          this.loginFail=true;
          this.deny=false;
        }

        ////console.log('-------data login-----',this.hashPassword,data[3]);
      });

      

      

       //this.router.navigate(['/default-layout/dashboard']);

       //this.loginFail=false;
    }else{
      this.loginFail=true;
      //alert('userpassword:null');
    }
  
  }

  fetchData(cb) {
    const req = new XMLHttpRequest();
    req.open('GET',  environment.url+'/api/getJSON_user.php?username='+this.username);

    req.onload = () => {
      cb(JSON.parse(req.response));
    };

    req.send();
  }
}
//dialog
@Component({
  selector: 'loading-dialog',
  templateUrl: 'loading-dialog.html',
})
export class signInDialog {
  Message = '';
  Title = '';
  constructor(public dialogRef: MdDialogRef<signInDialog>) { }
}


// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/sign-in/sign-in.ts